{
    "name": "Stevia",
    "binomial_name": "Stevia rebaudiana",
    "common_names": [
        "sweetleaf",
        "sweet leaf",
        "sugarleaf",
        "candyleaf"
    ],
    "description": "Stevia is tender, semi-tropical shrub in the Asteraceae (Sunflower) family that is native to Brazil and Paraguay. It is grown for it's sweet leaves, which can be used fresh or dried and ground into a powder also known as Stevia. Dried leaves are sweeter than fresh, and the powder is used as a sugar substitute. Stevia contains compounds that are 200-300 times sweeter than sugar, but pass through the digestive system without being broken down and absorbed. The plant has weak, floppy stems, slender, oblong leaves, and tubular, white, hermaphrodite flowers. Stevia does best in humid, wet environments. It is a perennial in regions where the temperature range is 21 to 43\u00b0 C, but can be grown as an annual or in containers in colder regions. Stevia cannot survive temperatures below 7\u00b0 C. The entire plant can be harvested in the fall once flower buds have appeared but not opened (the plant has a bitter aftertaste after flowers have opened). Cooler temperatures and shorter days increase the sweetness of the leaves.",
    "sun_requirements": "Full Sun",
    "sowing_method": "Direct seed indoors, cuttings, or cloned seedlings",
    "spread": 60,
    "row_spacing": 25,
    "height": 60,
    "growing_degree_days": 0,
    "companions": [],
    "image": "/crops/images/stevia.jpg",
    "icon": "/crops/icons/stevia.avif"
}